import api from './api';

export const reportService = {
  async getDashboardStats() {
    const response = await api.get('/reports/dashboard');
    return response.data.data;
  },
  
  async getProjectReport(params = {}) {
    const response = await api.get('/reports/projects', { params });
    return response.data.data;
  },
  
  async getClientReport(params = {}) {
    const response = await api.get('/reports/clients', { params });
    return response.data.data;
  },
  
  async getFinancialReport(params = {}) {
    const response = await api.get('/reports/financial', { params });
    return response.data.data;
  },
  
  async getTimeReport(params = {}) {
    const response = await api.get('/reports/time', { params });
    return response.data.data;
  }
};
